import { Address } from '@31third/common';
import { RebalancingAmountEntryDto } from './rebalancing-amount-entry.dto';
import { RebalancingAllocationEntryDto } from './rebalancing-allocation-entry.dto';
import { LiquiditySourceConfigDto } from 'common';

export class BaseRebalancingQueryDto {
  signer: Address;
  baseEntries: RebalancingAmountEntryDto[];
  targetEntries: RebalancingAllocationEntryDto[];
  maxDeviationFromTarget?: number;
  maxSlippage?: number;
  maxPriceImpact?: number;
  minExpirySec?: number;
  minTradeValue?: number;
  liquiditySourceConfig?: LiquiditySourceConfigDto;
  batchTrade?: boolean;
  revertOnError?: boolean;
  skipBalanceValidation?: boolean;
  failOnMissingPricePair?: boolean;
  async?: boolean;
  simulationTxOrigin?: Address;
}
